import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import './index.css'
import App from './App.tsx'
import ValeBonusPage from './pages/ValeBonusPage.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/valebonus" element={<ValeBonusPage />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
)
